import { LegalPage } from './legal/LegalPage';
import { doc } from './legal/content/personal-data-consent';

export const Personal = () => <LegalPage doc={doc} />;
